<template>
  <div class="container">
    <!-- pass name -->
    <section id="section-name">
      <InputComponent
        class="input-name"
        type="text"
        for="input-pass-name"
        :label_text="inputLabel"
        attribute="Pass Name"
        placeholder="Type pass name"
        v-model="form.pass_name"
        :v="$v.form.pass_name" />

      <small id="pass-help" class="form-text text-muted">
        Make sure that your pass name is unique from your other Pass - John-8/12/19
      </small>
    </section>

    <!-- Type of Pass -->
    <section id="section-type">
      <div class="form-group">
        <label>Choose type of pass</label>
        <div class="type-pass-content">
          <div class="form-check form-check-container">
            <input
              v-model="form.type_of_pass"
              class="form-check-input"
              type="radio"
              name="pass-type"
              value="Solo Pass">
            <label class="form-check-label" for="individual-pass">Solo Pass</label>
          </div>

          <div class="form-check">
            <input
              v-model="form.type_of_pass"
              class="form-check-input"
              type="radio"
              name="pass-type"
              value="Group Pass">
            <label class="form-check-label" for="group-pass">Group Pass</label>
          </div>

          <small
            v-if="error.type_of_pass"
            class="form-text text-muted error-message">
            {{ error.type_of_pass }}
          </small>
        </div>
      </div>
    </section>

    <section>
      <!-- visiting period -->
      <div class="form-group">
        <label for="visiting-date-input">Valid from</label>
        <div class="d-flex flex-row align-items-end validity-row">
          <datepicker format="dd MMMM yyyy"
            :disabledDates="disabledDates"
            v-model="form.visiting_date" />

          <div id="time-picker-container">
            <vue-timepicker
              format="hh:mm a"
              v-model="form.visit_time" />
          </div>
        </div>
        <small v-if="error.visit_date" class="form-text text-muted error-message">
          {{ error.visit_date }}
        </small>
      </div>

      <!-- validity period -->
      <div class="form-group">
        <label for="validity-date-input">Valid until</label>
        <div class="d-flex flex-row align-items-end validity-row">
          <datepicker format="dd MMMM yyyy"
            :disabledDates="disabledDates"
            v-model="form.validity_date" />

          <div id="time-picker-container">
            <vue-timepicker
              format="hh:mm a"
              v-model="form.valid_time" />
          </div>
        </div>
        <small v-if="error.valid_date" class="form-text text-muted error-message">
          {{ error.valid_date }}
        </small>
      </div>

      <!-- disposal period -->
      <div class="form-group">
        <label for="disposal-date-input">Pass disposal date</label>
        <span>&nbsp;&nbsp;&nbsp;&nbsp;</span>
        <span>&nbsp;&nbsp;&nbsp;&nbsp;</span>
        <span>&nbsp;&nbsp;</span>
        <select v-for="(period, i) in disposalDatePeriods" v-model="form.disposal_date" :key="(i + 20)">
          <option v-for="(date, index) in period.options" :value="date.value" :key="index">
            {{ date.option }}
          </option>
        </select>

        <small v-if="error.disposal_date" class="form-text text-muted error-message">
          {{ error.disposal_date }}
        </small>
      </div>

      <!-- floor number -->
      <InputComponent
        class="form-group w-50"
        type="text"
        for="input-floor-number"
        label_text="Floor and Unit Number"
        attribute="Floor and Unit Number"
        placeholder="What floor and unit number will be visited?"
        v-model="form.floor_number"
        :v="$v.form.floor_number" />

      <section v-if="isOrganizer">
        <InputComponent
          class="form-group w-50"
          type="text"
          for="input-building_name"
          label_text="Building Name"
          attribute="Building Name"
          placeholder="Building Name"
          v-model="form.building_name"
          :v="$v.form.building_name" />

        <InputComponent
          class="form-group w-50"
          type="text"
          for="input-building-address"
          label_text="Building Address"
          attribute="Building Address"
          placeholder="Building Address"
          v-model="form.building_address"
          :v="$v.form.building_address" />
      </section>

      <!-- reason to visit -->
      <InputComponent
        class="form-group w-50"
        type="text"
        for="input-reason-for-visit"
        label_text="Reason for Visit"
        attribute="Reason for Visit"
        placeholder="What is the reason for visit? e.g Meeting, booking, etc."
        v-model="form.reason_for_visit"
        :v="$v.form.reason_for_visit" />

      <!-- contact person -->
      <InputComponent class="form-group"
        type="text"
        for="input-contact-person"
        label_text="Contact Person"
        attribute="Contact Person"
        placeholder="John Doe"
        v-model="form.contact_person"
        :v="$v.form.contact_person" />

      <!-- contact email -->
      <InputComponent class="form-group"
        type="text"
        for="input-contact-email"
        label_text="Contact Email Address"
        attribute="Contact Email Address"
        placeholder="johndoe@mail.com"
        v-model="form.contact_email"
        :v="$v.form.contact_email" />

    </section>

    <!-- verify identity -->
    <!-- <section>
      <p>Verified Identity</p>
      <div class="form-check">
        <input
          v-model="form.verify_identity"
          class="form-check-input"
          type="checkbox"
          value="verify-identity">
        <label class="form-check-label" for="verify-identity">
          User must have a verified account to get this pass.
        </label>
      </div>
    </section> -->
    <!-- user details -->
    <section>
      <p>Details</p>
      <p>What details do you want to ask your recipient/s before they get this pass?</p>

      <div v-for="d in userDetailCategories" :key="d.id">
        <div class="form-check" v-if="d.name === 'Full Name'">
          <input
            v-model="form.included_pass_details"
            :v="$v.form.included_pass_details"
            type="checkbox"
            class="form-check-input"
            disabled
            :value="d.name">
          <label class="form-check-label">{{ d.name }}</label>
        </div>
        <div class="form-check" v-else>
          <input
            v-model="form.included_pass_details"
            :v="$v.form.included_pass_details"
            type="checkbox"
            class="form-check-input"
            :value="d.name">
          <label class="form-check-label">{{ d.name }}</label>
        </div>
      </div>
      <small
        v-if="error.included_pass_details"
        class="form-text text-muted error-message">
        {{ error.included_pass_details }}
      </small>
    </section>

    <section>
      <InputComponent class="form-group"
        type="text"
        for="input-floor-number"
        label_text="Reason for collecting personal information"
        attribute="Reason for collecting personal information"
        placeholder="Reason...."
        v-model="form.reason_for_collecting"
        :v="$v.form.reason_for_collecting" />
    </section>

    <br/>
    <!-- agreements -->
    <section>
      <p>Agreements</p>
      <p>Aside from the Data Privacy Agreement, what agreements do you want to include in this pass?</p>

      <div v-for="d in agreementCategories" :key="d.id">
        <div class="form-check">
          <input
            v-model="form.visiting_agreements"
            type="checkbox"
            class="form-check-input"
            :value="d.id">
          <label class="form-check-label" v-if="d.other_name !== 'none'">
            {{ d.other_name }}
          </label>
          <label class="form-check-label" v-else>
            {{ d.name }}
          </label>
        </div>

        <!-- <div class="form-check" v-if="d.name === 'Data Privacy Agreement' ||
          d.other_name === 'Data Privacy Agreement'">
          <input
            v-model="form.visiting_agreements"
            type="checkbox"
            class="form-check-input"
            disabled
            :value="d.id">
          <label class="form-check-label" v-if="d.other_name !== 'none'">
            {{ d.other_name }}
          </label>
          <label class="form-check-label" v-else>
            {{ d.name }}
          </label>
        </div>

        <div class="form-check" v-else>
          <input
            v-model="form.visiting_agreements"
            type="checkbox"
            class="form-check-input"
            :value="d.id">
          <label class="form-check-label" v-if="d.other_name !== 'none'">
            {{ d.other_name }}
          </label>
          <label class="form-check-label" v-else>
            {{ d.name }}
          </label>
        </div> -->
      </div>
      <small
        v-if="error.visiting_agreements"
        class="form-text text-muted error-message">
        {{ error.visiting_agreements }}
      </small>
    </section>

    <section v-if="form.type_of_pass !== 'Solo Pass'">
      <p>Request Pass Access</p>
      <div class="form-check">
        <input
          v-model="form.request_access"
          class="form-check-input"
          type="checkbox"
          value="request-access">
        <label class="form-check-label" for="request-access">
          User/s can request access to this pass.
        </label>
      </div>
    </section>

    <section v-if="form.request_access && form.type_of_pass !== 'Solo Pass'">
      <p>Request Needs Approval?</p>
      <div class="form-check">
        <input
          v-model="form.request_needs_approval"
          class="form-check-input"
          type="checkbox"
          value="request-access">
        <label class="form-check-label" for="request-access">
          User/s requesting access to this pass needs approval.
        </label>
      </div>
    </section>

    <section v-if="form.request_access && form.type_of_pass !== 'Solo Pass'">
      <p>Request Pass Access Intro</p>
      <div class="form-check">
        <textarea class="form-control"
          v-model="form.pass_intro"
          rows="5"
          type="checkbox"
          value="pass-intro"></textarea>
        <small v-if="error.pass_intro" class="form-text text-muted error-message">
          {{ error.pass_intro }}
        </small>
      </div>
      <br/>
    </section>

    <section>
      <p>Pass Questions</p>
      <div>
        <div class="div-add-question">
          <span class="add-question-text">Add questions? (Max of 5)</span>
          <button class="btn-primary btn-add-question" @click="addFormQuestion()">
            Add another question
          </button>
        </div>
        <div v-for="(item, index) in form.pass_access_questions" :key="index">
          <input class="form-group w-50"
            type="text"
            v-model="item.question"
            placeholder="Enter question here"
            value="item.question"/>
          <button class="simple-link" @click="deleteFormQuestion(index, $event)">
            <i class="fas fa-trash"></i>
          </button>
        </div>
        <small v-if="error.request_question" class="form-text text-muted error-message">
          {{ error.request_question }}
        </small>
      </div>
    </section>
    <br/>

    <section>
      <small v-if="error_message" class="form-text text-muted error-message">
        {{ error_message }}
      </small>
      <button @click="validateForm()" type="submit" class="btn btn-primary">
        {{ submitButtonName }}
      </button>
      <button @click="cancelEdit()" type="submit" class="btn btn-primary" v-if="action === 'edit'">
        Cancel
      </button>
    </section>
    <br/><br/>
  </div>
</template>

<style scoped>
/* Use /deep/ to target child of parent in component. */

/* https://bambielli.com/til/2018-08-19-how-to-target-child-components-with-scoped-css-in-vue/# */

.div-add-question {
  margin-top: -30px;
}

.add-question-text {
  margin-top: 10px;
}

.btn-add-question {
  background-color: #007bff;
  color: #fff;
  margin-left: 10px
}

/deep/ .input-name input {
  font-size: 36px;
  font-family: 'HKGrotesk-Bold', Helvetica, Arial, sans-serif;
  padding-top: 56px;
  border: none !important;
}

section {
  margin-bottom: 36px;
}

section p:first-child {
  font-family: 'HKGrotesk-Semibold', Helvetica, Arial, sans-serif;
  font-weight: normal;
}

section p:nth-child(2) {
  font-family: 'HKGrotesk', Helvetica, Arial, sans-serif;
  font-weight: normal;
}

.form-check-container {
  padding-top: 0px;
  padding-bottom: 16px;
}

.type-pass-content {
  margin-top: 24px;
}

.date-dropdown-container {
  padding: 24px 0;
  border-bottom: 1px solid #e5e9eb !important;
}

#time-picker-container {
  border-bottom: 1px solid #e5e9eb !important;
  margin-left: 24px;
}

.validity-row {

}

.form-check {
  margin: 12px 0;
}

/deep/ .date-dropdown-select-wrapper select {
  background: transparent;
  height: 20px;
  border: none;
  color: #0c3967;
}

/deep/ .form-group .time-picker input.display-time {
  border: none;
  height: auto;
  padding: 0 0 16px 4px;
}

/deep/ .time-picker .clear-btn {
  display: none;
}

/deep/ .vdp-datepicker input {
  border-width: 0 0 1px 0;
  padding: 16px 0;
}

</style>

<script>
import DateDropdown from 'vue-date-dropdown'
import VueTimepicker from 'vue2-timepicker'
import Datepicker from 'vuejs-datepicker'
import { required, email } from 'vuelidate/lib/validators'

import InputComponent from '@/components/form/InputComponent'

export default {
  components: {
    'date-dropdown': DateDropdown,
    'vue-timepicker': VueTimepicker,
    InputComponent,
    Datepicker
  },
  data() {
    return {
      disabledDates: {
        to: new Date(Date.now() - 8640000)
      },
      maxQuestion: 2,
      disposalDate: '',
      disposalDatePeriods: [
        {
          options: [
            { option: '15 days', value: '15 days' },
            { option: '1 month', value: '1 months' },
            { option: '3 months', value: '3 months' },
            { option: '6 months', value: '6 months' },
            { option: '1 year', value: '1 years' },
            { option: '2 years', value: '2 years' }
          ],
          selectedOption: '15 days'
        }
      ]
    }
  },
  props: {
    action: String,
    error_message: String,
    submitButtonName: String,
    isOrganizer: String,
    form: Object,
    error: Object,
    userDetailCategories: Array,
    agreementCategories: Array,
    validateBeforeSubmit: Function,
    cancelEdit: Function,
    updateErrorState: Function,
    addFormQuestion: Function,
    deleteFormQuestion: Function
  },
  validations: {
    form: {
      pass_name: { required },
      floor_number: { required },
      reason_for_visit: { required },
      contact_person: { required },
      reason_for_collecting: { required },
      building_name: { required },
      building_address: { required },
      contact_email: { required, email }
    }
  },
  methods: {
    validateForm() {
      this.$v.$touch()
      this.updateErrorState(this.$v.$invalid)
      this.validateBeforeSubmit()
    }
  },
  computed: {
    inputLabel() {
      return this.action === 'create' ? 'Add new pass' : ''
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/passes/PassForm.vue